<div class="page-content" *ngIf="!timerService.isForwarding">

     <div><button class="btn-back" title="{{Button.Back_alt | translate}}" (click)="onPreviousClick()" translate>{{Button.Previous}}</button></div>

     <h1 class="page-title" translate>{{'final_review.page_title'}}</h1>

     <div translate="final_review.text1"></div>
     <div [innerHTML]="'final_review.text2' | translate" class="padding-top-1em"></div>
     <div translate="final_review.text3" class="padding-top-1em"></div>


     <div id="aboutChild" class="padding-top-2em">
          <h2>{{'final_review.about_child.header' | translate: childNameParam}}</h2>

          <div class="div-table">
               <div class="div-table-row">
                    <div class="col-name" id="id_1" translate> {{ 'final_review.about_child.name' }}</div>
                    <div class="col-value" id="sid_1" translate>
                         {{childName}}
                    </div>
                    <div class="col-edit">
                         <ng-container *ngTemplateOutlet="edit; context:{page: 'aboutTheChild', pId: 'id_1', psId: 'sid_1'}"></ng-container>
                    </div>
               </div>
               <div class="div-table-row">
                    <div class="col-name" id="id_2" translate>{{ 'final_review.about_child.born_on' }}</div>
                    <div class="col-value" id="sid_2">{{getBirthDate(aboutChild.birthDay)}}</div>
                    <div class="col-edit">
                         <span [hidden]="data.isNextChild">
                                <ng-container *ngTemplateOutlet="edit; context:{page: 'setup1', pId: 'id_2', psId: 'sid_2'}"></ng-container>
                         </span>
                    </div>
               </div>
               <div class="div-table-row">
                    <div class="col-name" id="id_3" translate>{{ 'final_review.about_child.sex' }}</div>
                    <div class="col-value" id="sid_3">{{aboutChild.gender}}</div>
                    <div class="col-edit">
                         <ng-container *ngTemplateOutlet="edit; context:{page: 'aboutTheChild', pId: 'id_3', psId: 'sid_3'}"></ng-container>
                    </div>
               </div>
               <div class="div-table-row">
                    <div class="col-name" id="id_4" translate>{{ 'final_review.about_child.birth_weight' }}</div>
                    <div class="col-value" id="sid_4">{{childWeight}}</div>
                    <div class="col-edit">
                         <ng-container *ngTemplateOutlet="edit; context:{page: 'aboutTheChild', pId: 'id_4', psId: 'sid_4'}"></ng-container>
                    </div>
               </div>

               <div class="div-table-row" id="birthOrder" [hidden]="data.eligibility.birthType == '1'">
                  <div class="col-name" id="id_5" translate>{{ 'final_review.about_child.birth_order' }}</div>
                  <div class="col-value" id="sid_5"><span [translate]='childBirthOrder'></span></div>
                  <div class="col-edit">
                       <ng-container *ngTemplateOutlet="edit; context:{page: 'aboutTheChild', pId: 'id_5', psId: 'sid_5'}"></ng-container>
                  </div>
               </div>

               <div class="div-table-row">
                    <div class="col-name" id="id_6" translate>{{ 'final_review.about_child.birth_city' }}</div>
                    <div class="col-value" id="sid_6">{{data.aboutChild.cityName}}</div>
                    <div class="col-edit">
                         <ng-container *ngTemplateOutlet="edit; context:{page: 'aboutTheChild', pId: 'id_6', psId: 'sid_6'}"></ng-container>
                    </div>
               </div>
               <div class="div-table-row">
                    <div class="col-name" id="id_7" translate>{{ 'final_review.about_child.birth_place' }}</div>
                    <div class="col-value" id="sid_7"><span [translate]='placeOfBirth'></span></div>
                    <div class="col-edit">
                         <ng-container *ngTemplateOutlet="edit; context:{page: 'aboutTheChild', pId: 'id_7', psId: 'sid_7'}"></ng-container>
                    </div>
               </div>
               <div class="div-table-row">
                    <div class="col-name" id="id_8" translate>
                         {{ 'final_review.about_child.birthPlace.' + data.aboutChild.birthPlaceType}}
                    </div>
                    <div class="col-value" id="sid_8"> {{data.aboutChild.birthPlaceName}}
                    </div>
                    <div class="col-edit">
                         <ng-container *ngTemplateOutlet="edit; context:{page: 'aboutTheChild', pId: 'id_8', psId: 'sid_8'}"></ng-container>
                    </div>
               </div>
               <div class="div-table-row">
                    <div class="col-name" id="id_9" translate>{{ 'final_review.about_child.birth_attendant_type' }}</div>
                    <div class="col-value" id="sid_9"><span [translate]='attendantType'></span></div>
                    <div class="col-edit">
                         <ng-container *ngTemplateOutlet="edit; context:{page: 'aboutTheChild', pId: 'id_9', psId: 'sid_9'}"></ng-container>
                    </div>
               </div>
               <div class="div-table-row">
                    <div class="col-name" id="id_10" translate>{{ 'final_review.about_child.birth_attendant_name' }}</div>
                    <div class="col-value" id="sid_10">{{attendantName}}</div>
                    <div class="col-edit">
                         <ng-container *ngTemplateOutlet="edit; context:{page: 'aboutTheChild', pId: 'id_10', psId: 'sid_10'}"></ng-container>
                    </div>
               </div>
          </div>
     </div>
     
     <div style="clear:both"></div>

     <div *ngIf="birthParent">
        <div style="clear:both"></div>
        <ng-container *ngTemplateOutlet="aboutParent; context : {parent: birthParent, isBirthParent: 'Y', pIndex: -1, idIndex: 'bp'}"></ng-container>
     </div>

     <ng-container *ngFor="let nonBirthParent of nonBirthParents; let i = index">
          <div style="clear:both"></div>
          <ng-container *ngTemplateOutlet="aboutParent; context : {parent: nonBirthParent, isBirthParent: 'N', pIndex: i, idIndex: 'p'+i}"></ng-container>
     </ng-container>

     <div style="clear:both"></div>

     <div id="contactAddress" class="padding-top-2em">
          <h2 translate>{{'final_review.contact_info.header'}}</h2>
          <div class="div-table" class="padding-top-1em">
               <div class="div-table-row">
                    <div class="col-name" id="id_11" translate> {{ 'final_review.contact_info.phone' }}</div>
                    <div class="col-value" id="sid_11" translate>
                         {{phoneNumber}} {{phoneExt()}}
                    </div>
                    <div class="col-edit">
                         <ng-container *ngTemplateOutlet="edit; context:{page: 'contactAndMailInfo', pId: 'id_11', psId: 'sid_11'}"></ng-container>
                    </div>
               </div>

               <div class="div-table-row">
                    <div class="col-name" id="id_12" translate> {{ 'final_review.contact_info.daytime_phone' }}</div>
                    <div class="col-value" id="sid_12" translate>
                         {{daytimePhoneNumber}} {{daytimePhoneExt()}}
                    </div>
                    <div class="col-edit">
                         <ng-container *ngTemplateOutlet="edit; context:{page: 'contactAndMailInfo', pId: 'id_12', psId: 'sid_12'}"></ng-container>
                    </div>
               </div>

               <div class="div-table-row">
                    <div class="col-name" id="id_13" translate> {{ 'final_review.contact_info.street_number' }}</div>
                    <div class="col-value" id="sid_13" translate>
                         {{data.contact.address.streetNumber}}
                    </div>
                    <div class="col-edit">
                         <ng-container *ngTemplateOutlet="edit; context:{page: 'contactAndMailInfo', pId: 'id_13', psId: 'sid_13'}"></ng-container>
                    </div>
               </div>

               <div class="div-table-row">
                    <div class="col-name" id="id_14" translate> {{ 'final_review.contact_info.street_name' }}</div>
                    <div class="col-value" id="sid_14" translate>
                         {{data.contact.address.streetName}}
                    </div>
                    <div class="col-edit">
                         <ng-container *ngTemplateOutlet="edit; context:{page: 'contactAndMailInfo', pId: 'id_14', psId: 'sid_14'}"></ng-container>
                    </div>
               </div>

               <div class="div-table-row" *ngIf="!(data.contact.address.unit == '') ">
                    <div class="col-name" id="id_15" translate> {{ 'final_review.contact_info.unit' }}</div>
                    <div class="col-value" id="sid_15" translate>
                         {{data.contact.address.unit}}
                    </div>
                    <div class="col-edit">
                         <ng-container *ngTemplateOutlet="edit; context:{page: 'contactAndMailInfo', pId: 'id_15', psId: 'sid_15'}"></ng-container>
                    </div>
               </div>

               <div class="div-table-row" *ngIf="!(data.contact.address.poBox == '') ">
                    <div class="col-name" id="id_16" translate> {{ 'final_review.contact_info.po_box' }}</div>
                    <div class="col-value" id="sid_16" translate>
                         {{data.contact.address.poBox}}
                    </div>
                    <div class="col-edit">
                         <ng-container *ngTemplateOutlet="edit; context:{page: 'contactAndMailInfo', pId: 'id_16', psId: 'sid_16'}"></ng-container>
                    </div>
               </div>

               <div class="div-table-row" *ngIf="!(data.contact.address.buzz == '') ">
                    <div class="col-name" id="id_17" translate> {{ 'final_review.contact_info.buzzer_code' }}</div>
                    <div class="col-value" id="sid_17" translate>
                         {{data.contact.address.buzz}}
                    </div>
                    <div class="col-edit">
                         <ng-container *ngTemplateOutlet="edit; context:{page: 'contactAndMailInfo', pId: 'id_17', psId: 'sid_17'}"></ng-container>
                    </div>
               </div>
               <div class="div-table-row" *ngIf="!(data.contact.address.deliveryMode == '') ">
                    <div class="col-name" id="id_18" translate> {{ 'final_review.contact_info.delivery_mode' }}</div>
                    <div class="col-value" id="sid_18" translate>
                         {{ 'final_review.contact_info.delivery_code.' + getDeliveryCode(data.contact.address.deliveryMode) }}
                    </div>
                    <div class="col-edit">
                         <ng-container *ngTemplateOutlet="edit; context:{page: 'contactAndMailInfo', pId: 'id_18', psId: 'sid_18'}"></ng-container>
                    </div>
               </div>
               <div class="div-table-row" *ngIf="!(data.contact.address.deliveryMode == '') ">
                    <div class="col-name" id="id_19" translate> 
                         {{ 'final_review.contact_info.delivery.' +  getDeliveryCode(data.contact.address.deliveryMode) }}
                    </div>
                    <div class="col-value" id="sid_19" translate>
                         {{data.contact.address.deliveryAddr}}
                    </div>
                    <div class="col-edit">
                         <ng-container *ngTemplateOutlet="edit; context:{page: 'contactAndMailInfo', pId: 'id_19', psId: 'sid_19'}"></ng-container>
                    </div>
               </div>
               <div class="div-table-row">
                    <div class="col-name" id="id_20" translate> {{ 'final_review.contact_info.city' }}</div>
                    <div class="col-value" id="sid_20" translate>
                         {{data.contact.address.base.city}}
                    </div>
                    <div class="col-edit">
                         <ng-container *ngTemplateOutlet="edit; context:{page: 'contactAndMailInfo', pId: 'id_20', psId: 'sid_20'}"></ng-container>
                    </div>
               </div>
               <div class="div-table-row">
                    <div class="col-name" id="id_21" translate *ngIf="!(data.contact.address.chk_international == 'Y')">
                         {{ 'final_review.contact_info.province' }}
                    </div>
                    <div class="col-name" id="id_21" translate *ngIf="data.contact.address.chk_international == 'Y'">
                         {{ 'final_review.contact_info.state' }}
                    </div>
                    <div class="col-value" id="sid_21" translate>
                         {{getProvince(data.contact.address)}}
                    </div>
                    <div class="col-edit">
                         <ng-container *ngTemplateOutlet="edit; context:{page: 'contactAndMailInfo', pId: 'id_21', psId: 'sid_21'}"></ng-container>
                    </div>
               </div>
               <div class="div-table-row" *ngIf="data.contact.address.chk_international == 'Y'">
                    <div class="col-name" id="id_22" translate> {{ 'final_review.contact_info.country' }}</div>
                    <div class="col-value" id="sid_22" translate>
                         {{getCountryName(data.contact.address.base)}}
                    </div>
                    <div class="col-edit">
                         <ng-container *ngTemplateOutlet="edit; context:{page: 'contactAndMailInfo', pId: 'id_22', psId: 'sid_22'}"></ng-container>
                    </div>
               </div>
               <div class="div-table-row">
                    <div class="col-name" id="id_23" translate *ngIf="!(data.contact.address.chk_international == 'Y')">
                         {{ 'final_review.contact_info.postal_code_ca' }}
                    </div>
                    <div class="col-name" id="id_23" translate *ngIf="data.contact.address.chk_international == 'Y'">
                         {{ 'final_review.contact_info.postal_code_intl' }}
                    </div>
                    <div class="col-value" id="sid_23" translate>
                         {{data.contact.address.postalCode.toUpperCase()}}
                    </div>
                    <div class="col-edit">
                         <ng-container *ngTemplateOutlet="edit; context:{page: 'contactAndMailInfo', pId: 'id_23', psId: 'sid_23'}"></ng-container>
                    </div>
               </div>
          </div>
     </div>
     
     <div style="clear:both"></div>
     
     <!-- div class="padding-top-2em" *ngIf="!isLegalCustody()"  --->

     <div class="alert-box">
          <notice-box *ngIf="data.eligibility.certifyingParentCount >= 2" margin="2/0" outer-style="width:100%">
               <span translate>{{'final_review.critical_box.text'}}</span>
          </notice-box> 
     </div>

     <div id="birthRegConsent" class="padding-top-2em">
          <h3 translate>{{'final_review.birth_registration.header'}}</h3>
          <div>
               <ng-checkbox [(ng-model)]="eligibility.birthCertifyConsent"
                            [(ng-error)]="error_invalidBirthCertify"
                            id="birthCertifyCheckbox">
                    <span [innerHTML]=" 'final_review.birth_registration.content' | translate: {openStatement: openStatementParam, parentNames: parentCertifyName, certifie: certifieParam} ">
                    </span>
                    <span>{{consentContent}}</span>
               </ng-checkbox>
          </div>
     </div>

     <div id="certifyChild" class="padding-top-2em" *ngIf="data.aboutChild.isParentAgreeOnLastName == 'Y' || data.aboutChild.isParentAgreeOnSingleName == 'Y' ">
          <h3>{{'final_review.certify_child.header' | translate: {lastNameOrSingleName: lastOrSingleNameParam} }}</h3>
          <div>
               <ng-checkbox [(ng-model)]="eligibility.chkAgreeToLastName"
                            [(ng-error)]="error_invalidLastNameCertify"
                            id="agreeToLastNameCheckbox">
                    <div [innerHTML]=" 'final_review.certify_child.checkbox.content' | translate: {openStatement: openStatementParam, parentNames: parentCertifyName, childLastName: childLastName} ">
                    </div>
               </ng-checkbox>
          </div>
     </div>

     <div id="collectionNotice" class="padding-top-2em">
          <h3 translate>{{'final_review.collection_notice.header'}}</h3>
          <div>
               <ng-checkbox [(ng-model)]="eligibility.chkReadDisclosure"
                            [(ng-error)]="error_notice"
                            (click)="onNoticeClick($event)"
                            id="collectionNoticeCheckbox"
                            [title]="'final_review.collection_notice.checkbox.alt_text' | translate">
                    <span [innerHTML]=" 'final_review.collection_notice.checkbox.content1' | translate: {openStatement: openStatementParam, parentNames: parentCertifyName} ">
                    </span>
                    <a [title]="'final_review.collection_notice.checkbox.notice_link.alt_text' | translate" href="#" 
                         (click)="onNoticeClick($event)" translate>
                         {{'final_review.collection_notice.checkbox.notice_link.label'}}</a>
                    <span translate> {{'final_review.collection_notice.checkbox.content2'}}</span>
               </ng-checkbox>
              
          </div>
     </div>


     <div class="btn-div">
          <button class="btn-next" title="{{Button.Next_alt|translate}}" (click)="onNextClick()" translate>
               {{Button.Next}}
          </button>
     </div>

</div>


<ng-template #aboutParent let-parent="parent" let-isBirthParent="isBirthParent" let-index="pIndex" let-idIndex="idIndex">

     <div id="aboutNonBirthParent" class="padding-top-2em">
          <h2>{{'final_review.about_parent.header' | translate: {parentName : parent.name.getFullName()} }}
          </h2>
          <div class="div-table">
               <div class="div-table-row">
                    <div class="col-name" id="id_p1_{{idIndex}}" translate *ngIf="parent.name.chk_singleName != 'Y' "> 
                         {{ 'final_review.about_parent.parent_name' }}
                    </div>
                    <div class="col-name" id="id_p1_{{idIndex}}" translate *ngIf="parent.name.chk_singleName == 'Y' "> 
                         {{ 'final_review.about_parent.parent_name_single' }}
                    </div>
                    <div class="col-value" id="sid_p1_{{idIndex}}" translate>
                         {{parent.name.getFullName()}}
                    </div>
                    <div class="col-edit">
                         <ng-container *ngTemplateOutlet="edit; context:{page: 'aboutParent', pIndex: index, pId: 'id_p1_'+ idIndex, psId: 'sid_p1_'+ idIndex}"></ng-container>
                    </div>
               </div>

               <div class="div-table-row">
                    <div class="col-name" id="id_p2_{{idIndex}}" translate *ngIf="parent.name.chk_singleName != 'Y' "> 
                         {{ 'final_review.about_parent.last_name' }}
                    </div>
                    <div class="col-name" id="id_p2_{{idIndex}}" translate *ngIf="parent.name.chk_singleName == 'Y' "> 
                         {{ 'final_review.about_parent.last_name_single' }}
                    </div>
                    <div class="col-value" id="sid_p2_{{idIndex}}" translate *ngIf="parent.isOtherLastNameAtBirth == 'Y' ">
                         {{parent.lastNameAtBirth}}
                    </div>
                    <div class="col-value" translate *ngIf="parent.isOtherLastNameAtBirth != 'Y' ">
                         <div class="col-name" id="sid_p2_{{idIndex}}" translate *ngIf="parent.name.chk_singleName == 'Y' "> 
                              {{ parent.name.single }}
                         </div>
                         <div class="col-name" id="sid_p2_{{idIndex}}" translate *ngIf="parent.name.chk_singleName != 'Y' "> 
                              {{parent.name.last}}
                         </div>
                         
                    </div>
                    <div class="col-edit">
                         <ng-container *ngTemplateOutlet="edit; context:{page: 'aboutParent_other', pIndex: index, pId: 'id_p2_'+ idIndex, psId: 'sid_p2_'+ idIndex}"></ng-container>
                    </div>
               </div>
              
               <div class="div-table-row" *ngIf="parent.isOtherPreviousName == 'Y' ">
                    <div class="col-name" id="id_p3_{{idIndex}}" translate *ngIf="parent.name.chk_singleName != 'Y'"> 
                         {{ 'final_review.about_parent.other_last_name' }}
                    </div>
                    <div class="col-name" id="id_p3_{{idIndex}}" translate *ngIf="parent.name.chk_singleName == 'Y' "> 
                         {{ 'final_review.about_parent.other_last_name_single' }}
                    </div>
                    <div class="col-value" id="sid_p3_{{idIndex}}" translate>
                         {{parent.previousLastName}}
                    </div>
                    <div class="col-edit">
                         <ng-container *ngTemplateOutlet="edit; context:{page: 'aboutParent_other', pIndex: index, pId: 'id_p3_'+ idIndex, psId: 'sid_p3_'+ idIndex}"></ng-container>
                    </div>
               </div>

               <div class="div-table-row">
                    <div class="col-name" id="id_p4_{{idIndex}}" translate> {{ 'final_review.about_parent.title' }}
                    </div>
                    <div class="col-value" id="sid_p4_{{idIndex}}" translate>
                        <span [hidden]="!parent.parentType" translate>{{ 'shared.parentType.' + parent.parentType }}</span>
                    </div>
                    <div class="col-edit">
                         <ng-container *ngTemplateOutlet="edit; context:{page: 'aboutParent_other', pIndex: index, pId: 'id_p4_'+ idIndex, psId: 'sid_p4_'+ idIndex}"></ng-container>
                    </div>
               </div>

               <div class="div-table-row" *ngIf="isBirthParent == 'Y' ">
                    <div class="col-name" id="id_p5_{{idIndex}}" translate> {{ 'final_review.about_parent.marital_status' }}
                    </div>
                    <div class="col-value" id="sid_p5_{{idIndex}}" translate>
                        <span [hidden]="!parent.maritalStatus" translate>{{'shared.maritalStatus.' + parent.maritalStatus}}</span>
                    </div>
                    <div class="col-edit">
                         <ng-container *ngTemplateOutlet="edit; context:{page: 'aboutParent_other', pIndex: index, pId: 'id_p5_'+ idIndex, psId: 'sid_p5_'+ idIndex}"></ng-container>
                    </div>
               </div>

               <div class="div-table-row" *ngIf="isBirthParent == 'Y' && data.eligibility.isBornThroughSurrogacy != 'Y' ">
                    <div class="col-name" id="id_p6_{{idIndex}}" translate> {{ 'final_review.about_parent.preg_duration' }}
                    </div>
                    <div class="col-value" id="sid_p6_{{idIndex}}" translate>
                         {{parent.pregnancyDuration}} <span [hidden]="!parent.pregnancyDuration">weeks</span>
                    </div>
                    <div class="col-edit">
                         <ng-container *ngTemplateOutlet="edit; context:{page: 'aboutParent_other', pIndex: index, pId: 'id_p6_'+ idIndex, psId: 'sid_p6_'+ idIndex}"></ng-container>
                    </div>
               </div>

               <div class="div-table-row">
                    <div class="col-name" id="id_p7_{{idIndex}}" translate> {{ 'final_review.about_parent.dob' }}
                    </div>
                    <div class="col-value" id="sid_p7_{{idIndex}}" translate>
                         {{getBirthDate(parent.whenParentBorn)}}
                    </div>
                    <div class="col-edit">
                         <ng-container *ngTemplateOutlet="edit; context:{page: 'aboutParent_other', pIndex: index, pId: 'id_p7_'+ idIndex, psId: 'sid_p7_'+ idIndex}"></ng-container>
                    </div>
               </div>

               <div class="div-table-row">
                    <div class="col-name" id="id_p8_{{idIndex}}" translate> {{ 'final_review.about_parent.age' }}
                    </div>
                    <div class="col-value" id="sid_p8_{{idIndex}}" translate>
                         {{ getParentAge(parent.whenParentBorn) }}
                    </div>
                    <div class="col-edit">
                         <ng-container *ngTemplateOutlet="edit; context:{page: 'aboutParent_other', pIndex: index, pId: 'id_p8_'+ idIndex, psId: 'sid_p8_'+ idIndex}"></ng-container>
                    </div>
               </div>

               <div class="div-table-row">
                    <div class="col-name" id="id_p9_{{idIndex}}" translate> {{ 'final_review.about_parent.birth_place' }}
                    </div>
                    <div class="col-value" id="sid_p9_{{idIndex}}">
                         {{getParentPlaceOfBirth(parent.placeOfBirth)}}
                    </div>
                    <div class="col-edit">
                         <ng-container *ngTemplateOutlet="edit; context:{page: 'aboutParent_other', pIndex: index, pId: 'id_p9_'+ idIndex, psId: 'sid_p9_'+ idIndex}"></ng-container>
                    </div>
               </div>
          </div>
     </div>
</ng-template>


<ng-template #edit let-page="page" let-pIndex="pIndex" let-pId="pId" let-psId="psId">
     <a attr.aria-labelledby="{{pId}} {{psId}}" tabindex="0" class="edit-link" [title]="'final_review.edit_link.edit_alt' | translate" (keypress)="keyPressEnter($event, page, pIndex)" (click)="onEdit(page, pIndex)" style="cursor: pointer;">{{'final_review.edit_link.label' | translate}}</a>
</ng-template>

<light-box #editLightBox outer-class="information-box">
      <information outer-style="width:100%">

            <header-x (close)="onEditClose()"></header-x>

            <h2 style="text-align: center; margin-top:0.7em">{{'final_review.edit_link.confirm_header' | translate}}</h2>

            <div style="text-align: center; margin-top:0.4em">
                  {{'final_review.edit_link.confirm_text' | translate}}
            </div>
            <div class="btn-div-notice" style="text-align: center;">
                  <button class="btn-next-notice" title="{{Button.Next_alt|translate}}" (click)="onEditContinue()" translate>
                        {{'final_review.edit_link.continue_btn' | translate}}
                  </button>
            </div>
      </information>
     
</light-box>

<light-box input-class="white-box" #noticeOfCollectionBox outer-style="font-size:0.88em; margin-top:1em">

     <div style="margin-left: 0.9em; margin-right: 0.9em; padding-top: 0.4em;">
          <information outer-class="full">
               <div class="info-title" *ngIf="data.eligibility.isCustodyOtherThanParent == 'Y' || data.eligibility.certifyingParentCount == 1">
                  <strong><span translate='final_review.notice_lightbox.instruction_i_agree'></span></strong>
               </div>
               <div class="info-title" *ngIf="!(data.eligibility.isCustodyOtherThanParent == 'Y') && data.eligibility.certifyingParentCount > 1">
                  <strong><span translate='final_review.notice_lightbox.instruction_we_agree'></span></strong>
               </div>
          </information>
     </div>

     <div class="notice-padding">
          <h3 translate class='header-lightbox'>
               {{'final_review.notice_lightbox.header'}}
          </h3>
     </div>

     <div class="margin1">
          <div translate class="padding-top-1em" [innerHTML]=" 'final_review.notice_lightbox.content1' | translate" class="notice-padding">
          </div>

          <div translate class="padding-top-1em notice-padding">
               {{'final_review.notice_lightbox.content2'}}
          </div>

          <div translate class="padding-top-1em notice-padding">
               {{'final_review.notice_lightbox.content3'}}
               <a routerLink="/{{ orgContactPath }}" href="#" (click)="onNoticeClose()"
                    title="{{'final_review.notice_lightbox.org_contact.alt_text' | translate}}">{{
                    "final_review.notice_lightbox.org_contact.label" | translate
               }}</a>.
          </div>
     </div>
     <div style="margin-top: 1em; margin-bottom:2.8em" style="float:right; cursor:pointer">

          <a tabindex="0" role="button" style="margin-right:1em"
                (click)="onNoticeClose()" (keypress)="keyPress($event)">
               {{'final_review.notice_lightbox.close_link.label' | translate}}
          </a>
     </div>

     <div class="btn-div" style="margin-top: 3em;">   
          
               <button class="btn-next-notice" (click)="noticeOnAgree()" alt-text="final_review.notice_lightbox.agree_btn.alt_text" translate>
                    <div *ngIf="data.eligibility.isCustodyOtherThanParent == 'Y' || data.eligibility.certifyingParentCount == 1" translate>{{'final_review.notice_lightbox.agree_btn.label_i_agree' }}</div>
                    <div *ngIf="!(data.eligibility.isCustodyOtherThanParent == 'Y') && data.eligibility.certifyingParentCount > 1" translate>{{'final_review.notice_lightbox.agree_btn.label_we_agree' }}</div>
               </button> 
          
    </div>  
    
</light-box>